import Fuse from 'fuse.js';

const options = {
  shouldSort: true,
  threshold: 0.5,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 3,
  keys: ['name', 'tags'],
};

const search = (list, keyword) => {
  const fuse = new Fuse(list, options);
  const result = fuse.search(keyword);

  result.sort((a, b) => b.contentType.includes('productRange'));

  return result;
};

export default search;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/product-search.js